<template lang="html">
  <div class="profile-profile-wrapper">
    <div class="profile-picture">
      <div class="image-wrapper" :class="{ editing: edit }">
        <img :src="getImage" alt="" />
      </div>
      <template v-if="!edit">
        <p class="user-name">
          {{ userData.usr_name }} {{ userData.usr_username }}
        </p>
      </template>
    </div>
    <div class="button-wrap" v-if="edit">
      <label
        for="myfile"
        ref="label"
        style="margin-top: 10px"
        class="btn dark-blue"
      >
        {{ $t("main.editImage") }}
      </label>
      <input
        id="myfile"
        type="file"
        accept=".png, .jpg, .jpeg"
        @change="photoData($event)"
        ref="fileInput"
        hidden
      />
      <button
        style="margin-top: 10px"
        class="btn dark-blue outlined"
        v-if="new_img"
        @click="resetFile"
      >
        {{ $t("item.remove") }}
      </button>
    </div>
    <h1>{{ $t("profile.title.profile_title") }}</h1>
    <div class="input-wrap">
      <input-view
        v-model="editData['usr_username']"
        :label="$t('main.username')"
        :disabled="!edit"
      ></input-view>
      <template v-if="edit">
        <input-view
          v-model="editData['usr_password']"
          :label="$t('main.password')"
          type="password"
          :disabled="!edit"
        ></input-view>
        <small>{{ $t("register.passwordRules") }}</small>
        <input-view
          v-model="editData['usr_password2']"
          :label="$t('main.repeat_password')"
          type="password"
          :disabled="!edit"
        ></input-view>
      </template>
      <input-view
        v-model="editData['usr_email']"
        :label="$t('main.email')"
        disabled
      ></input-view>
      <input-view
        v-model="editData['usr_name']"
        :label="$t('main.nameLastName')"
        :disabled="!edit || !!userData.usr_is_organisation"
      ></input-view>
      <input-view
        v-model="editData['usr_phone_number']"
        v-if="userData['usr_phone_number'] || edit"
        :label="$t('main.phone')"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['usr_phone_number1']"
        v-if="userData['usr_phone_number1'] || edit"
        :label="$t('main.phone') + ' 2'"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['usr_phone_number2']"
        v-if="userData['usr_phone_number2'] || edit"
        :label="$t('main.phone') + ' 3'"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['usr_phone_number3']"
        v-if="userData['usr_phone_number3'] || edit"
        :label="$t('main.phone') + ' 4'"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['usr_region']"
        v-if="userData['usr_region'] || edit"
        :label="$t('main.location')"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['usr_address']"
        v-if="userData['usr_address'] || edit"
        :label="$t('main.address')"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['usr_postal_code']"
        v-if="userData['usr_postal_code'] || edit"
        :label="$t('main.usr_postal_code')"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['usr_org_pib']"
        v-if="userData['usr_org_pib'] || edit"
        :label="$t('main.pib')"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['usr_org_id']"
        v-if="userData['usr_org_id'] || edit"
        :label="$t('main.mbf')"
        :disabled="true"
      />
      <input-view
        v-model="editData['usr_org_full_name']"
        v-if="userData['usr_org_full_name'] || edit"
        :label="$t('main.usr_org_full_name')"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['usr_org_bank']"
        v-if="userData['usr_org_bank'] || edit"
        :label="$t('main.bank')"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['usr_org_contact']"
        v-if="userData['usr_org_contact'] || edit"
        :label="$t('main.orgContact')"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['usr_org_contact_person']"
        v-if="userData['usr_org_contact_person'] || edit"
        :label="$t('main.usr_org_contact_person')"
        :disabled="!edit"
      ></input-view>
      <input-view
        v-model="editData['osr_id']"
        v-if="userData['osr_id'] || edit"
        :label="$t('main.services')"
        :disabled="!edit"
      ></input-view>
      <dropdown
        v-if="userData['otp_name'] || edit"
        :selected="editData.otp_name"
        :default-text="$t('main.firmType')"
        :list="organisationType"
        :label="$t('main.firmType')"
        :disabled="!edit"
        @changeOption="setOrgType"
      ></dropdown>
      <dropdown
        v-if="userData['cnt_name'] || edit"
        :defaultText="$t('main.country')"
        :selected="editData.cnt_name"
        :list="countries"
        @changeOption="setCountries"
        :disabled="!edit"
      ></dropdown>
      <input-view
        v-for="social in socialsT"
        :label="social.sct_name"
        v-model="social.link"
        :key="social.sct_id"
        :disabled="!edit"
      ></input-view>
      <dropdown
        :default-text="$t('main.usr_email_language')"
        :selected="
          editData.usr_email_language
            ? editData.usr_email_language.toUpperCase()
            : editData.usr_email_language
        "
        :list="emailLanguage"
        @changeOption="setLanguageEmail"
        :disabled="!edit"
      ></dropdown>
      <div class="file-wrap">
        <file-display
          v-if="userData['usr_business_register'] || edit"
          :file-name="
            (usr_business_register && usr_business_register.name) ||
              $t('main.apr1')
          "
          @download-file="handleDownload('apr_link')"
          @remove-file="usr_business_register = null"
          :downloadable="
            userData['usr_business_register'] &&
              !(usr_business_register && usr_business_register.name && edit)
          "
          :closable="
            usr_business_register && usr_business_register.name && edit
          "
        ></file-display>
        <file-input v-if="edit" @change="apr"></file-input>
        <a
          :href="imageLink(userData['usr_business_register'])"
          class="hidden"
          target="_blank"
          ref="apr_link"
        ></a>
      </div>

      <div class="file-wrap">
        <file-display
          v-if="userData['usr_tax_info'] || edit"
          :file-name="(usr_tax_info && usr_tax_info.name) || $t('main.file')"
          @download-file="handleDownload('tax_link')"
          @remove-file="usr_tax_info = null"
          :downloadable="
            userData['usr_tax_info'] &&
              !(usr_tax_info && usr_tax_info.name && edit)
          "
          :closable="usr_tax_info && usr_tax_info.name && edit"
        ></file-display>
        <file-input v-if="edit" @change="taxInfo"></file-input>
        <a
          :href="imageLink(userData['usr_tax_info'])"
          class="hidden"
          target="_blank"
          ref="tax_link"
        ></a>
      </div>

      <input-view
        v-model="usr_pr_text"
        v-if="userData['usr_pr_text'] || edit"
        :label="$t('main.pr')"
        :disabled="!edit"
        type="textarea"
        max-length="999"
      ></input-view>

      <div class="checkbox-wrap">
        <input
          class="info-value"
          type="checkbox"
          id="notification"
          name="vehicle1"
          v-model="userData.usr_notifications"
          :disabled="!edit"
        />
        <label class="info-key info-key2" for="notification">
          {{ $t("profile.sugestions.notifications") }}
        </label>
      </div>
      <div class="checkbox-wrap">
        <input
          class="info-value"
          type="checkbox"
          id="newsletter"
          name="vehicle2"
          v-model="userData.usr_newsletter"
          :disabled="!edit"
        />
        <label class="info-key info-key2" for="newsletter">
          {{ $t("profile.sugestions.newsletter") }}
        </label>
      </div>
      <div class="checkbox-wrap">
        <input
          class="info-value"
          type="checkbox"
          id="privacy"
          name="vehicle3"
          v-model="userData.usr_private"
          :disabled="!edit"
        />
        <label class="info-key info-key2" for="privacy">
          {{ $t("profile.sugestions.privacyS") }}</label
        >
      </div>

      <div class="checkbox-wrap">
        <span>{{ $t("item.rate") }}: </span>
        <rating
          v-if="userData['usr_rating']"
          :rating="parseFloat(userData.usr_rating)"
        ></rating>
      </div>
    </div>
    <div class="button-wrap">
      <template v-if="edit">
        <button class="btn dark-blue outlined" @click="edit = false">
          {{ $t("button.button_cancel").toUpperCase() }}
        </button>
        <button class="btn dark-blue" @click="save">
          {{ $t("button.button_save").toUpperCase() }}
        </button>
      </template>
      <template v-else>
        <button
          class="btn dark-blue"
          :class="{ disabled: !editable }"
          @click="edit = true"
        >
          {{ $t("button.button_edit_data").toUpperCase() }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { api, baseURL } from "@/api";
import dropdown from "@/components/dropdown.vue";
import Rating from "@/components/rating.vue";
import { mapState } from "vuex";
import InputView from "../shared/testInput.vue";
import defaultProfileImage from "@/assets/images/defaultProfileImage.png";
import FileDisplay from "../shared/FileDisplay.vue";
import FileInput from "../shared/FileInput.vue";

export default {
  name: "profileProfile",
  components: {
    dropdown,
    Rating,
    InputView,
    FileDisplay,
    FileInput
  },
  data() {
    return {
      editable: true,
      userData: {},
      mainData: [
        "usr_email",
        "usr_phone_number",
        "usr_phone_number1",
        "usr_phone_number2",
        "usr_phone_number3",
        "usr_username",
        "usr_name",
        "usr_password",
        "usr_password2",
        "cnt_name",
        "usr_region",
        "usr_address",
        "usr_org_pib",
        "org_type",
        "usr_org_bank",
        "osr_name",
        "osr_id",
        "otp_name",
        "org_services",
        "usr_org_contact",
        "usr_org_contact_person",
        "usr_org_id",
        "usr_rating",
        "socials",
        "usr_postal_code",
        "usr_tax_info",
        "usr_business_register",
        "usr_email_language",
        "usr_org_full_name"
        // 'usr_pr_text'
      ],
      organisationType: [],
      organisationServices: [],
      countries: [],
      socialsT: [],
      socials: [],
      edit: false,
      editData: {},
      errMsg: null,
      errMsgPIC: null,
      imageData: "",
      new_img: null,
      notification: false,
      newsletter: false,
      privacy: false,
      usr_business_register: null,
      usr_tax_info: null,
      sendData: {},
      usr_pr_text: null,
      emailLanguage: [
        { label: "RS", value: "rs" },
        { label: "EN", value: "en" }
      ]
    };
  },
  computed: {
    ...mapState(["userName"]),
    getImage() {
      if (this.imageData) {
        return this.imageData;
      }
      if (this.userData.usr_image) {
        return this.imageLink(this.userData.usr_image);
      }
      return defaultProfileImage;
    }
  },
  methods: {
    async getSocialTypes() {
      await api.getSocialTypes().then(res => {
        this.socialsT = res.data.data;
        this.setSocial();
      });
    },
    setSocial() {
      for (let i = 0; i < this.socialsT.length; i++) {
        this.$set(this.socialsT[i], "link", "");
      }
      if (this.userData["socials"] !== null) {
        for (let i = 0; i < this.socialsT.length; i++) {
          for (let j = 0; j < this.userData.socials.length; j++) {
            if (this.socialsT[i].sct_id === this.userData.socials[j].sct_id) {
              this.socialsT[i].link = this.userData.socials[j].link;
            }
          }
        }
      }
    },
    save() {
      this.setDataForSend();
      if (!this.matchMail(this.editData.usr_email)) {
        this.$toast.error(this.$t("errors.registration.email"), {
          duration: 8000
        });
        return;
      }
      if (!this.matchPhone(this.editData.usr_phone_number)) {
        this.$toast.error(this.$t("errors.registration.phone"), {
          duration: 8000
        });
        return;
      }
      if (
        this.editData.usr_password === null ||
        this.editData.usr_password === ""
      ) {
        delete this.editData.usr_password;
        delete this.editData.usr_password2;
        delete this.sendData.usr_password;
      } else {
        if (this.editData.usr_password.length < 8) {
          this.$toast.error(this.$t("errors.registration.password"), {
            duration: 8000
          });
          return;
        }
        if (
          this.editData.usr_password &&
          this.editData.usr_password !== this.editData.usr_password2
        ) {
          this.$toast.error(this.$t("errors.registration.samePasswords"), {
            duration: 8000
          });
          return;
        }
        /* if (this.editData.usr_password.length < 8) {
          this.errMsg = this.$t('errors.registration.password')
          return
        } */
      }
      if (this.mustHaveValue(this.sendData)) return;

      // this.editData.usr_notifications = (this.userData.usr_notifications === true || this.userData.usr_notifications === 1) ? 1 : 0
      // this.editData.usr_newsletter = (this.userData.usr_newsletter === true || this.userData.usr_newsletter === 1) ? 1 : 0
      // this.editData.usr_private = (this.userData.usr_private === true || this.userData.usr_private === 1) ? 1 : 0
      this.editData.socials = JSON.stringify(this.socialsT);
      this.sendData.socials = this.editData.socials;
      console.log(this.sendData.socials);
      // if (this.sendData.hasOwnProperty('usr_notifications')) this.sendData.usr_notifications = (this.userData.usr_notifications === true || this.userData.usr_notifications === 1) ? 1 : 0
      // if (this.sendData.hasOwnProperty('usr_newsletter')) this.sendData.usr_newsletter = (this.userData.usr_newsletter === true || this.userData.usr_newsletter === 1) ? 1 : 0
      // if (this.sendData.hasOwnProperty('usr_private')) this.sendData.usr_private = (this.userData.usr_private === true || this.userData.usr_private === 1) ? 1 : 0
      this.sendData.usr_notifications =
        this.userData.usr_notifications === true ||
        this.userData.usr_notifications === 1
          ? 1
          : 0;
      this.sendData.usr_newsletter =
        this.userData.usr_newsletter === true ||
        this.userData.usr_newsletter === 1
          ? 1
          : 0;
      this.sendData.usr_private =
        this.userData.usr_private === true || this.userData.usr_private === 1
          ? 1
          : 0;

      let params = this.paramsAppend(this.sendData);
      if (this.imageData !== "") {
        this.editData.image = this.new_image;
        params.append("image", this.new_img);
      }
      if (this.usr_business_register !== null) {
        params.append("usr_business_register", this.usr_business_register);
      }
      if (this.usr_tax_info !== null) {
        params.append("usr_tax_info", this.usr_tax_info);
      }
      if (this.usr_pr_text !== null && this.usr_pr_text !== "") {
        params.append("usr_pr_text", this.usr_pr_text);
      }
      // send data------------------------------------
      api
        .editProfileData(params)
        .then(res => {
          console.log(res);
          if (res.data.res === "ok") {
            this.getUserInfo();
            this.edit = false;
            this.usr_business_register = null;
            this.usr_tax_info = null;
            this.usr_pr_text = null;
            this.$toast.success(this.$t("main.successfulEditProfile"), {
              duration: 8000
            });
            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }, 200);
            return;
          }
          this.$toast.error(this.$t("errors.registration.errorB"), {
            duration: 8000
          });
        })
        .catch(e => {
          this.handleErrors(e.response);
        });
      // this.edit = false
    },
    handleErrors(response) {
      console.log(response);
      if (response.status === 403) {
        this.$toast.error(this.$t("errors.profile.forbiden"), {
          duration: 8000
        });
      }
      if (response.status === 409) {
        this.$toast.error(this.$t("errors.profile.min.username_err"), {
          duration: 8000
        });
        return;
      }
      if (response.data.validation && response.data.validation === "min") {
        this.$toast.error(this.$t("errors.profile.min." + response.data.name), {
          duration: 8000
        });
      }
      this.getUserInfo();
      this.edit = false;
    },
    getUserInfo() {
      api
        .getUserInfo()
        .then(res => {
          this.userData = res.data.data;
          this.editable = res.data.editable;
          if (this.userData.usr_username !== this.userName) {
            this.$store.commit("setUserName", this.userData.usr_username);
            localStorage.setItem("userName", this.userData.usr_username);
          }
          this.setUpEditData();
          this.getSocialTypes();
        })
        .catch(e => {
          console.log(e);
        });
    },
    mustHaveValue(userData) {
      if (this.userData.usr_is_organisation !== 1) {
        return false;
      }
      for (let variable in userData) {
        if (
          (variable === "org_pib" ||
            variable === "org_id" ||
            variable === "org_type" ||
            variable === "org_contact" ||
            variable === "usr_org_contact_person" ||
            variable === "sr_org_registration_number" ||
            variable === "usr_org_full_name" ||
            variable === "usr_org_bank") &&
          (userData[variable] === "" ||
            userData[variable] === null ||
            userData[variable] === undefined)
        ) {
          this.$toast.error(this.$t("errors.profile.empty_field"), {
            duration: 8000
          });
          return true;
        }
      }

      return false;
    },
    imageLink(image) {
      return baseURL + image;
    },
    setUpEditData() {
      for (var variable in this.userData) {
        if (this.userData.hasOwnProperty(variable)) {
          this.$set(this.editData, variable, this.userData[variable]);
        }
      }
      this.usr_pr_text = this.userData["usr_pr_text"];
      this.$set(this.editData, "usr_password", "");
      this.$set(this.editData, "usr_password2", "");
    },
    setDataForSend() {
      this.sendData = {};
      for (var i = 0; i < this.mainData.length; i++) {
        // if (this.editData.hasOwnProperty(variable)) {
        if (
          this.editData[this.mainData[i]] != this.userData[this.mainData[i]]
        ) {
          if (this.mainData[i] == "osr_id") {
            this.sendData["org_services"] = this.editData[this.mainData[i]];
          } else if (this.mainData[i] == "cnt_name") {
            console.log(this.editData[this.mainData[i]]);
            this.sendData["cnt_id"] = this.editData[this.mainData[i]].value;
          } else {
            this.sendData[this.mainData[i]] = this.editData[this.mainData[i]];
          }
        }
        //   }
        // if (this.editData.usr_email_language !== undefined && this.editData.usr_email_language !== null) {
        //   this.sendData['usr_email_language'] = this.editData['usr_email_language']
        // }
      }
      // if (this.userData['usr_is_organisation'] !== 1) {
      //   if (this.editData['usr_org_full_name'] !== undefined && this.editData['usr_org_full_name'] !== '') this.sendData['usr_org_full_name'] = this.editData['usr_org_full_name']
      //   if (this.editData['usr_org_bank'] !== undefined && this.editData['usr_org_bank'] !== '') this.sendData['usr_org_bank'] = this.editData['usr_org_bank']
      //   if (this.editData['usr_org_id'] !== undefined && this.editData['usr_org_id'] !== '') this.sendData['usr_org_id'] = this.editData['usr_org_id']
      //   if (this.editData['usr_org_pib'] !== undefined && this.editData['usr_org_pib'] !== '') this.sendData['usr_org_pib'] = this.editData['usr_org_pib']
      //   if (this.editData['usr_org_contact_person'] !== undefined && this.editData['usr_org_contact_person'] !== '') this.sendData['usr_org_contact_person'] = this.editData['usr_org_contact_person']
      // }
      return this.sendData;
    },
    setDataForSendOld() {
      this.sendData = {};
      for (var i = 0; i < this.mainData.length; i++) {
        // if (this.editData.hasOwnProperty(variable)) {
        if (
          this.editData[this.mainData[i]] !== this.userData[this.mainData[i]]
        ) {
          if (this.mainData[i] === "otp_name") {
            this.sendData["org_type"] = this.editData[this.mainData[i]];
          } else {
            this.sendData[this.mainData[i]] = this.editData[this.mainData[i]];
          }
        }
        //   }
        // if (this.editData.usr_email_language !== undefined && this.editData.usr_email_language !== null) {
        //   this.sendData['usr_email_language'] = this.editData['usr_email_language']
        // }
      }
      // if (this.userData['usr_is_organisation'] !== 1) {
      //   if (this.editData['usr_org_full_name'] !== undefined && this.editData['usr_org_full_name'] !== '') this.sendData['usr_org_full_name'] = this.editData['usr_org_full_name']
      //   if (this.editData['usr_org_bank'] !== undefined && this.editData['usr_org_bank'] !== '') this.sendData['usr_org_bank'] = this.editData['usr_org_bank']
      //   if (this.editData['usr_org_id'] !== undefined && this.editData['usr_org_id'] !== '') this.sendData['usr_org_id'] = this.editData['usr_org_id']
      //   if (this.editData['usr_org_pib'] !== undefined && this.editData['usr_org_pib'] !== '') this.sendData['usr_org_pib'] = this.editData['usr_org_pib']
      //   if (this.editData['usr_org_contact_person'] !== undefined && this.editData['usr_org_contact_person'] !== '') this.sendData['usr_org_contact_person'] = this.editData['usr_org_contact_person']
      // }
      return this.sendData;
    },
    // ---  Type of business organization - Tip firme/Oblik organizovanja*
    getOrganisationType() {
      api
        .getOrganisationType()
        .then(res => {
          let data = res.data.data;
          if (!data) return;
          for (let i = 0; i < data.length; i++) {
            let obj = {
              label: data[i].otp_name,
              value: data[i].otp_id
            };
            this.organisationType.push(obj);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // do not needed
    getOrganisationServices() {
      api
        .getOrganisationServices()
        .then(res => {
          let data = res.data.data;
          if (!data) return;
          for (let i = 0; i < data.length; i++) {
            let obj = {
              label: data[i].osr_name,
              value: data[i].osr_id
            };
            this.organisationServices.push(obj);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getCountries() {
      api
        .getCountries()
        .then(res => {
          let data = res.data.data;
          for (var i = 0; i < data.length; i++) {
            let obj = {
              label: data[i].cnt_name,
              value: data[i].cnt_id
            };
            this.countries.push(obj);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    setOrgType(e) {
      console.log(e);
      this.editData.org_name = e;
      this.editData.otp_name = e.label;
      this.editData.org_type = e.value;
      this.editData = Object.assign({}, this.editData);
    },
    setOrgServices(e) {
      this.editData.osr_name = e;
      this.editData.osr_id = e.value;
      this.editData.org_services = e;
      this.editData = Object.assign({}, this.editData);
    },
    setCountries(e) {
      this.editData.cnt_name = e;
      this.editData.usr_country = e.value;
      this.editData = Object.assign({}, this.editData);
    },
    setLanguageEmail(e) {
      this.editData.usr_email_language = e.value;
      this.editData = Object.assign({}, this.editData);
    },
    matchMail(v) {
      let mailformat = /^(\w+.?)+@(\w+.?)+\.\w+$/;
      if (v.match(mailformat)) {
        return true;
      }
      return false;
    },
    matchPhone(v) {
      let phoneformat = /^(\+|0{2})(\d ?){7,15}$/;
      if (v.match(phoneformat)) {
        return true;
      }
      return false;
    },
    handleDownload(ref) {
      this.$refs[ref].click();
    },
    photoData(e) {
      this.new_img = e.target.files[0];

      if (this.new_img) {
        if (this.new_img.size > 409600) {
          this.$toast.error(this.$t("errors.registration.bigImage"), {
            duration: 8000
          });
          this.resetFile();
          return;
        }
        let reader = new FileReader();
        reader.onload = e => {
          this.imageData = e.target.result;
        };
        console.log(this.new_img);
        reader.readAsDataURL(this.new_img);
      }
    },
    resetFile() {
      let input = this.$refs.fileInput;
      input.type = "text";
      input.type = "file";
      this.new_img = null;
      this.imageData = "";
    },
    apr(files) {
      this.usr_business_register = files[0];
    },
    resetAprFile() {
      let input = this.$refs.apr;
      input.type = "text";
      input.type = "file";
      this.usr_business_register = null;
    },
    taxInfo(files) {
      // this.usr_tax_info = null
      this.usr_tax_info = files[0];
    },
    resetTaxFile() {
      let input = this.$refs.tax;
      input.type = "text";
      input.type = "file";
      this.usr_tax_info = null;
    },
    paramsAppend(obj) {
      let params = new FormData();
      for (let x in obj) {
        params.append(x, obj[x]);
      }
      return params;
    }
  },
  activated() {
    this.getUserInfo();
    this.getOrganisationType();
    this.getOrganisationServices();
    this.getCountries();
  },
  deactivated() {
    this.edit = false;
  }
};
</script>

<style lang="scss" scoped>
.profile-profile-wrapper {
  text-align: center;

  .profile-picture {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .user-name {
      text-align: center;
      font-size: 17px;
      font-weight: bold;
      line-height: 28px;
    }
    .image-wrapper {
      width: 60px;
      height: 60px;
      overflow: hidden;
      border-radius: 6px;
      margin: 0 auto;
      &.editing {
        width: 100px;
        height: 100px;
      }
      img {
        width: 100%;
        object-fit: cover;
      }
    }
    @media screen and (min-width: 768px) {
      flex-direction: row;
      align-items: center;
      .image-wrapper {
        margin: unset;
      }
      .user-name {
        text-align: left;
      }
    }
  }
  .button-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    .btn {
      // width: fit-content;
      display: block;
    }
  }
  .input-wrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 400px;
    margin: 20px 0;
    .checkbox-wrap {
      margin: 5px 0;
      text-align: left;
    }
    .file-wrap {
      margin: 10px 0;
    }
  }
  @media screen and (min-width: 768px) {
    // padding: 0 16px 16px 16px;
    padding: 0 46px 46px 46px;
    .button-wrap {
      margin-top: 10px;
      flex-direction: row;
      justify-content: flex-start;
    }
    text-align: left;
  }
}
</style>
<style lang="scss">
.profile-profile-wrapper {
  .dropdown {
    width: 100%;
    min-width: 200px !important;
  }
  .option {
    overflow-wrap: break-word;
    height: auto !important;
    padding-top: 10px;
    padding-bottom: 10px;
    // width: 100%;
    white-space: normal !important;
  }
}
.borderRe {
  border: 0 !important;
}
</style>
